import { render, staticRenderFns } from "./deducList_new.vue?vue&type=template&id=3765859e&scoped=true"
import script from "./deducList_new.vue?vue&type=script&lang=js"
export * from "./deducList_new.vue?vue&type=script&lang=js"
import style0 from "./deducList_new.vue?vue&type=style&index=0&id=3765859e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3765859e",
  null
  
)

export default component.exports